export const SET_USER_INFO = 'SET_USER_INFO';
export const RESET_USER_INFO = 'RESET_USER_INFO';
export const SET_CATEGORIES_LIST = 'SET_CATEGORIES_LIST';
export const SET_RELATED_POSTS = 'SET_RELATED_POSTS';
export const SET_CURRENT_POST = 'SET_CURRENT_POST';
export const SET_CATEGORIES_STATUS = 'SET_CATEGORIES_STATUS';
export const SET_POSTS_DETAILS = 'SET_POSTS_DETAILS';
export const SET_INTRODUCTION = 'SET_INTRODUCTION';
export const TOGGLE_CATEGORY = 'TOGGLE_CATEGORY';
export const HIDE_CATEGORY = 'HIDE_CATEGORY';
export const CLOSE_CATEGORIES = 'CLOSE_CATEGORIES';
export const SET_COURSE_PROGRESS = 'SET_COURSE_PROGRESS';



// WEBPACK FOOTER //
// ./src/screens/Index/store/types.js